/* OMNICHANNEL-65 - InsiderOne Web SDK: globale Push-Funktion für alle InsiderQueue Events */
/* Liegt bewusst im global-head Bundle (nicht im global Footer-Bundle wie eventObserver.js),
   da bereits im <head> injizierte InsiderOne Page-Type Pushes (siehe insiderone.setup.typoscript)
   diese Funktion benötigen, bevor der restliche JS-Footer-Code geladen wird. */
function push2insider(objInsider) {

    if (!window.insiderOneEnabled) {
        return;
    }

    var allConsented =
        document.cookie.indexOf('cookieConsented-analysis=1') !== -1 &&
        document.cookie.indexOf('cookieConsented-marketing=1') !== -1 &&
        document.cookie.indexOf('cookieConsented-personalization=1') !== -1;

    if (!allConsented) {

        console.log('NO CONSENT for InsiderOne Tracking');
        return;

    } else {

        // console.log("%c push2insider() ", "background: #0080a3; color: #fff", objInsider);
        console.log("%c push2insider() ", "background: #afca14; color: #fff", JSON.stringify(objInsider));
        window.InsiderQueue = window.InsiderQueue || [];
        window.InsiderQueue.push(objInsider);

    }

}
